import { Injectable } from '@angular/core';
function _getWindow(): any {
  return window;
}

@Injectable({
  providedIn: 'root',
})
export class GoogleTagManagerService {
  private window;
  constructor() {
    this.window = _getWindow();
  }
  private pingHome(obj) {
    if (obj) this.window.dataLayer.push(obj);
  }
  logPageView(url) {
    const hit = {
      event: 'content-view',
      pageName: url,
    };
    this.pingHome(hit);
  }
  logEvent(event, category, action) {
    const hit = {
      event,
      category,
    };
    this.pingHome(hit);
  }
}
